// Pinia instance เดียวของทั้งหน้า
//
// ทุก mount point ใน script.ts และทุก popup ใน vue-core.ts ต้อง app.use() ตัวนี้
// ห้ามใครเรียก createPinia() เองอีก: pinia.install() เรียก setActivePinia() ทุกครั้ง
// ดังนั้น pinia ตัวที่ mount ล่าสุดจะยึด activePinia ไว้แม้ component นั้น unmount แล้ว
// — useStore() ที่ถูกเรียก "นอก" component context (axios interceptor ใน http.ts)
// resolve store จาก activePinia จึงได้ store เปล่าของ popup ที่ยังไม่ hydrate
// → request หลุด Authorization header → 401 → เด้ง login ทั้งที่ login อยู่
import { createPinia } from 'pinia';

export const pinia = createPinia();
